import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { clearError } from '../store/error/action-creators';
import { ErrorKey } from '../app-active-error/ErrorKey';
import StandardError from '../app-active-error/StandardError';
import { setStandardLoading } from '../store/loading-status/action-creators';
import { fetchExistingAccounts } from '../store/existing-accounts/action-creators';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
const LOG = Logger.getLogger('ExistingAccountsFetchError');

const ExistingAccountsFetchError = () => {
  const errorKey = ErrorKey.ExistingAccountsFetchFailed;
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    onSentenceWithLinkClick: event => {
      event.preventDefault();
      dispatch(fetchExistingAccounts()).catch(error => {
        LOG.error('Error retrying fetching existing user accounts', {
          extra: getSentryExtra(error)
        });
      });
      dispatch(setStandardLoading());
      dispatch(clearError());
    }
  });
};

export default ExistingAccountsFetchError;